




import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getUser } from '@/services/graph/user.graph';

@Component
export default class UserChip extends Vue {
  @Prop({ type: String, required: true }) uid!: string;

  private user: { _id: string; name: string; email: string } | null = null;

  @Watch('uid', { immediate: true })
  async loadUser(uid: string) {
    if (uid) {
      const user = await getUser(uid);
      this.user = user;
    }
  }
}
